// 打印小票设置（localStorage 持久化）

const STORE_NAME_KEY = 'receipt_store_name';
const FOOTER_KEY = 'receipt_footer';
const PAPER_WIDTH_KEY = 'receipt_paper_width';
const SALE_LABEL_KEY = 'receipt_sale_label';
const PURCHASE_LABEL_KEY = 'receipt_purchase_label';
const PROMO_KEY = 'receipt_promo';

// 默认列宽（仅供 escpos 计算分隔线总宽使用，版式上已不使用分列）
const DEFAULT_COL_WIDTHS = { name: 12, qty: 4, price: 7, sub: 7 };

export const receiptSettings = {
  // 店名（顶居中）
  getStoreName() {
    return localStorage.getItem(STORE_NAME_KEY) || '';
  },
  setStoreName(v) {
    localStorage.setItem(STORE_NAME_KEY, v || '');
  },

  // 页脚（底居中）
  getFooter() {
    return localStorage.getItem(FOOTER_KEY) || '谢谢惠顾';
  },
  setFooter(v) {
    localStorage.setItem(FOOTER_KEY, v || '谢谢惠顾');
  },

  // 纸张宽度：58 或 80（mm）
  getPaperWidth() {
    return Number(localStorage.getItem(PAPER_WIDTH_KEY)) || 80;
  },
  setPaperWidth(v) {
    localStorage.setItem(PAPER_WIDTH_KEY, String(v));
  },

  // 销售单标题（默认 "销售单"，可改 "出货单" 等）
  getSaleLabel() {
    return localStorage.getItem(SALE_LABEL_KEY) || '销售单';
  },
  setSaleLabel(v) {
    localStorage.setItem(SALE_LABEL_KEY, v || '销售单');
  },

  // 进货单标题（默认 "进货单"，可改 "收货单" 等）
  getPurchaseLabel() {
    return localStorage.getItem(PURCHASE_LABEL_KEY) || '进货单';
  },
  setPurchaseLabel(v) {
    localStorage.setItem(PURCHASE_LABEL_KEY, v || '进货单');
  },

  // 根据 type 取对应标题
  getTypeLabel(type) {
    return type === 'purchase'
      ? this.getPurchaseLabel()
      : this.getSaleLabel();
  },

  // 底部品牌广告（茶意荟 / 微信二维码）
  // 结构：{ enabled, brand, lines: [string], qrText, qrCaption, qrSize }
  getPromo() {
    try {
      const raw = localStorage.getItem(PROMO_KEY);
      if (raw) return { ...defaultPromo(), ...JSON.parse(raw) };
    } catch (e) { /* ignore */ }
    return defaultPromo();
  },
  setPromo(v) {
    const merged = { ...defaultPromo(), ...(v || {}) };
    localStorage.setItem(PROMO_KEY, JSON.stringify(merged));
  }
};

// 默认广告配置
function defaultPromo() {
  return {
    enabled: false,
    brand: '茶意荟',
    lines: [
      '好茶 · 好价 · 好服务',
      '产地直供  零售批发',
      '散茶礼盒  企业定制'
    ],
    qrText: 'https://u.wechat.com/EFtqM2vqQ4Wk_U_FOSah7bo?s=2',
    qrCaption: '扫码加微信  享会员价',
    qrSize: 6
  };
}

// 默认列宽导出，前端 escpos.js 计算分隔线宽度用
export { DEFAULT_COL_WIDTHS };